import { FC } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import { ViewContainer } from "components/grid";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { NAVIGATION_ITEMS } from "constants/settings";
import {
  selectHasContactFormsManuallyCreated,
  selectHasDefaultWidgetContactFormAdded,
} from "store/entities/contact-forms/selectors";
import {
  selectHasDoneLiveChatSelectiveImportBefore,
  selectHasEverDoneFullLiveChatDataImport,
  selectHasLiveChatIntegration,
  selectIsOpenWidgetConnected,
  selectIsOpenWidgetTeamValid,
} from "store/entities/integrations";
import { selectIsTrial } from "store/entities/subscriptions";
import { selectTicketsForwardedToHelpDesk } from "store/views/tickets/selectors";

import { DataImportButton } from "./DataImportButton";
import { NavigationItems } from "./NavigationItems";
import { getNavigationItemsWithBadges } from "./badgeConditions";

const SettingsSideNavigation: FC = () => {
  const ticketsForwardedToHelpDesk = useSelector(selectTicketsForwardedToHelpDesk);
  const hasEverDoneFullLiveChatDataImport = useSelector(selectHasEverDoneFullLiveChatDataImport);
  const selectiveImportCompleted = useSelector(selectHasDoneLiveChatSelectiveImportBefore);
  const anyLiveChatImportFinished = hasEverDoneFullLiveChatDataImport || selectiveImportCompleted;
  const isOpenWidgetConnected = useSelector(selectIsOpenWidgetConnected);
  const isOpenWidgetTeamValid = useSelector(selectIsOpenWidgetTeamValid);
  const isLiveChatIntegrationEnabled = useSelector(selectHasLiveChatIntegration);
  const hasContactFormsManuallyCreated = useSelector(selectHasContactFormsManuallyCreated);
  const hasDefaultWidgetContactFormAdded = useSelector(selectHasDefaultWidgetContactFormAdded);

  const isTrial = useSelector(selectIsTrial);
  const shouldShowDataImportButton = isTrial && !anyLiveChatImportFinished;

  const activeItemId = location.pathname;
  const hasContactForms = hasContactFormsManuallyCreated || hasDefaultWidgetContactFormAdded;

  return (
    <ViewContainer title="Settings">
      <Flex column height="100%" overflow="auto">
        <Block flex={1}>
          <NavigationItems
            navigationItems={getNavigationItemsWithBadges(
              NAVIGATION_ITEMS,
              isLiveChatIntegrationEnabled,
              hasContactForms,
              ticketsForwardedToHelpDesk,
              isOpenWidgetConnected,
              isOpenWidgetTeamValid
            )}
            activeItem={activeItemId}
          />
        </Block>
        {shouldShowDataImportButton && <DataImportButton />}
      </Flex>
    </ViewContainer>
  );
};

export default withRouter(SettingsSideNavigation);
